import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getUserSubscriptions(params) {
    const { baseUrl, brandId, country, accessKey, email, uberToken, clientId } = params;

    invariant(baseUrl, 'baseUrl is a required param of getUserSubscriptions()');
    invariant(brandId, 'brandId is a required param of getUserSubscriptions()');
    invariant(country, 'country is a required param of getUserSubscriptions()');

    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/usersubscriptions/@self?withOptions=true`;

    if (accessKey && email) {
        return authenticatedRequest(new Request(`${url}&accessKey=${accessKey}&email=${email}`), undefined, clientId);
    }
    return labelRequest(authenticatedRequest(new Request(url), uberToken, clientId), 'getUserSubscriptions');
}
